/**
 * Presentation Layer - Navbar
 * Main navigation component
 */

"use client";

import { Cloud } from "lucide-react";
import { useTranslations } from "next-intl";
import { ThemeSwitcher } from "./theme-switcher";
import { LanguageSwitcher } from "./language-switcher";
import { AnimatedInteractive, Animated } from "../animated";

export default function Navbar() {
  const t = useTranslations("common");

  return (
    <Animated
      show={true}
      variant="fade"
      className="sticky top-0 z-50 w-full border-b border-border bg-card/80 backdrop-blur-lg"
    >
      <nav>
        <div className="container mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex h-14 sm:h-16 items-center justify-between gap-2">
            {/* Logo Section */}
            <AnimatedInteractive className="flex items-center gap-2 sm:gap-3 min-w-0">
              <div className="flex h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg">
                <Cloud className="h-5 w-5 sm:h-6 sm:w-6 text-white" />
              </div>
              <div className="min-w-0 flex-1">
                <h1 className="text-sm sm:text-xl font-bold text-foreground truncate">
                  {t("appName")}
                </h1>
                <p className="hidden md:block text-xs text-muted-foreground truncate">
                  {t("appTagline")}
                </p>
              </div>
            </AnimatedInteractive>

            {/* Actions Section */}
            <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
              <ThemeSwitcher />
              <LanguageSwitcher />
            </div>
          </div>
        </div>
      </nav>
    </Animated>
  );
}
